module.exports = __webpack_public_path__ + "img/nicholas_nuzzi.9ffa0918.jpg";